import { handleActions } from "redux-actions";
import {
  PUBLIC_POWER_REQUEST,
  PUBLIC_POWER_SUCCESS,
  PUBLIC_AREA_POWER_COSTS_REQUEST,
  PUBLIC_AREA_POWER_COSTS_SUCCESS,
} from "./types";

const initState = {
  publicAreaPowerConsumptionData: null,
  publicAreaPowerCosts: null,
};

export default handleActions(
  {
    [PUBLIC_POWER_REQUEST]: (state) => ({
      ...state,
      publicAreaPowerConsumptionData: null,
    }),
    [PUBLIC_POWER_SUCCESS]: (state, { payload }) => {
      return { ...state, publicAreaPowerConsumptionData: payload };
    },
    [PUBLIC_AREA_POWER_COSTS_REQUEST]: (state) => ({
      ...state,
      publicAreaPowerCosts: null,
    }),
    [PUBLIC_AREA_POWER_COSTS_SUCCESS]: (state, { payload }) => {
      return { ...state, publicAreaPowerCosts: payload };
    },
  },
  initState
);
